/**
 * Notice deferral for the beta notice and the feedback dialog.
 *
 * Neither may sit over a crisis surface. PROD audit P0-2 (4 Oct 2026): on a
 * phone the beta notice opened over the crisis support bar. C-09 (5 Oct 2026,
 * Minor per the interim clinical authority, card 3): the feedback dialog had
 * the same fault. On /assistant the bar can rise on any send, /crisis is the
 * crisis page, and the floating chat widget carries the bar too.
 *
 * Deferred is not dismissed: the notice opens once the veteran leaves the
 * path or closes the widget.
 */
import { useLocation } from 'react-router-dom';
import { useAdvocateWidget } from '../contexts/AdvocateWidgetContext';

export const BETA_NOTICE_DEFERRED_PATHS = ['/assistant', '/crisis'];

export function isNoticeDeferred(pathname, widgetOpen) {
  return BETA_NOTICE_DEFERRED_PATHS.includes(pathname) || Boolean(widgetOpen);
}

export function useNoticeDeferred() {
  const { pathname } = useLocation();
  const { isOpen } = useAdvocateWidget();
  return isNoticeDeferred(pathname, isOpen);
}
